/** @type {Record<string, string>} */
export const STATUS_COLOR_MAP = {
  // Primary / Blue (informational)
  scheduled: 'primary',
  ready: 'primary',

  // Purple / Purple (in-progress)
  started: 'purple',
  progress: 'purple',
  in_progress: 'purple',

  // Success / Green
  success: 'success',
  active: 'success',
  approved: 'success',
  finalized: 'success',
  signed_and_locked: 'success',
  signed: 'success',
  created: 'success',
  confirmed: 'success',
  accepted: 'success',
  paid: 'success',
  balance_paid: 'success',

  // Danger / Red
  cancelled: 'danger',
  canceled: 'danger',
  rejected: 'danger',
  declined: 'danger',
  denied: 'danger',
  failed: 'danger',
  balance_not_paid: 'danger',

  // Warning / Amber
  needs_review: 'warning',
  expired: 'warning',
  not_started: 'warning',
  out_of_stock: 'warning',
  pending: 'warning',
  requested: 'warning',
  balance_partially_paid: 'warning',

  // Neutral / Gray (draft)
  unconfirmed: 'neutral',
  checked_in: 'neutral',
  used: 'neutral',
  draft: 'neutral',
  awaiting_co_sign: 'neutral',
  unread: 'neutral',
  read: 'neutral',
  awaiting_signature: 'neutral',
  inactive: 'neutral',
  discontinued: 'neutral',
  acknowledged: 'neutral',
  archived: 'neutral',
  no_claim: 'neutral'
};
